import {
  ActionReducerMapBuilder,
  createAction,
  createReducer,
  PayloadAction,
} from "@reduxjs/toolkit";
import { DefaultFilesState, FilesState } from "../state/stateItems";
import { TFileItem, TFileSubfoldersItem } from "@/data/types";
import { getAllFilesAsync, getFileByIdAsync } from "../actions";

const handleGetAllFilesAsync = (
  state: FilesState,
  action: PayloadAction<{ items: TFileItem[], subfolders: TFileSubfoldersItem[] }>
) => {
  if (!action?.payload) {
    return state;
  }

  const { items, subfolders } = action.payload;

  state.items = items;
  state.subfolders = subfolders
};

const handleGetFileByIdAsync = (
  state: FilesState,
  action: PayloadAction<TFileItem>
) => {
  if (!action?.payload) {
    return state;
  }

  const file = action.payload;

  state.currentFile = file;
};

const reducerBuilder = (builder: ActionReducerMapBuilder<FilesState>) => {
  builder.addCase(getAllFilesAsync.fulfilled.type, handleGetAllFilesAsync);
  builder.addCase(getFileByIdAsync.fulfilled.type, handleGetFileByIdAsync);
};

export default createReducer(DefaultFilesState, reducerBuilder);